import { Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/store";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { getVendorsId, reset } from "../redux/VendorSlice";
import Loading from "src/components/Loading";
import VendorInfoData from "../components/VendorInfoData";
import { PageTemplate } from "src/layout/components/PageTemplate";

interface CustomizedState {
  id: string;
}

const RoleInfo = () => {
  const location = useLocation();
  const state = location.state as CustomizedState;
  const { id } = state;

  const [data, setData] = useState([] as any);
  const [loading, setLoading] = useState(true);

  const {
    singleVendor,
    isDeleteLoading,
    isError,
    isDeleteError,
    isSuccess,
    isDeleteSuccess,
    message,
    deleteMessage,
  } = useSelector((state: RootState) => state.vendor);

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(message, { variant: "error" });
    }
    if (isSuccess) {
      setData(singleVendor);
      setLoading(false);
    }
    return () => {
      dispatch(reset());
    };
  }, [isError, isSuccess, message, dispatch]);

  useEffect(() => {
    if (isDeleteError) {
      enqueueSnackbar(deleteMessage, { variant: "error" });
    }
    if (isDeleteSuccess) {
      enqueueSnackbar(deleteMessage, { variant: "success" });
      navigate("/vendors/vendors-list");
    }
    return () => {
      dispatch(reset());
    };
  }, [isDeleteError, isDeleteSuccess, deleteMessage, dispatch]);

  useEffect(() => {
    const infoValue = {
      id: Number(id),
    };
    dispatch(getVendorsId(infoValue));
  }, []);

  return (
    <PageTemplate
      isTransparent
      crumbs={[
        {
          label: "vendors",
          href: "/vendors/vendors-list",
          depth: -1,
        },
        {
          label: "vendor information",
        },
      ]}
    >
      {loading ? (
        <Loading />
      ) : (
        <VendorInfoData isDeleteLoading={isDeleteLoading} data={data} />
      )}
    </PageTemplate>
  );
};

export default RoleInfo;
